// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__2tpOe","list":"BalanceDue_list__TAqp5","listRow":"BalanceDue_listRow__3oKYO","total":"BalanceDue_total__1-1oh"};